module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (4).0097d53d.jpg";